import animatedLogo from '../../../assets/icons/cluey_plus_animated_logo.gif';

const ClueyPlusLoader = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-5">
      <img src={animatedLogo} alt="Loading..." className="h-[50px]" />
    </div>
  );
};

export default ClueyPlusLoader;
